import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { action, runInAction, IObservableArray, observable, computed, makeObservable } from "mobx";
import { AlertError } from "General/ErrorTypes";
import { API } from "General/API";

export abstract class ListStore<T> extends CoreStore {
  list: IObservableArray<T>;

  constructor(identifier = "id") {
    super({ omitAllStoresArray: false, id: identifier });

    makeObservable(this, {
      list: observable,
      clear: action,
      asArray: computed,
      getItem: action,
      setItem: action,
      removeItem: action,
      fetch: action,
    });

    this.clear();
  }

  @handleStoreState()
  async fetch(filter?: object) {
    const items: Array<T> = await API.getData(this.url(), filter);

    runInAction(() => {
      if (Array.isArray(items)) {
        const data = this.processRecievedData(items);
        this.list.replace([...data]);
      } else {
        const errorMessages: string[] = [];
        errorMessages.push(`Status: Did not receive Array.`);
        errorMessages.push(`URL: ${this.url()}`);
        throw new AlertError("Error", errorMessages);
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  processRecievedData(items: any[]) {
    return items;
  }

  clear() {
    this.list = [] as IObservableArray<T>;
  }

  get asArray(): Array<T> {
    return this.list.slice();
  }

  find(field: string, value: object) {
    return this.list.find((val: T) => {
      return val[field] === value;
    });
  }

  getItem(id: number) {
    if (typeof id === "string") {
      id = parseInt(id, 10);
    }
    return this.list.find((val: T) => {
      return val[this.identifier] === id;
    });
  }

  /**
   * Updates or adds an entry in the Collection
   *
   * @param o the new Item
   */
  setItem(o: T) {
    const index = this.list.findIndex((val: T) => {
      return val[this.identifier] === o[this.identifier];
    });
    if (index === -1) {
      this.list.push(o);
    } else {
      this.list[index] = o;
    }
  }

  removeItem(id: number) {
    this.list = this.list.filter((val: T) => {
      return val[this.identifier] !== id;
    }) as IObservableArray<T>;
  }
}
